import {
  ChangeDetectionStrategy,
  Component,
  computed,
  contentChild,
  Directive,
  inject,
  input,
  TemplateRef
} from '@angular/core';
import {
  LotteryListComponent,
  LotteryListItemDirective
} from "../../../../components/lottery-list/lottery-list.component";
import {ApartmentWithApplicationInfo, ApplicationService} from "../../../application.service";
import {NgTemplateOutlet} from "@angular/common";
import {NotificationDialogContentComponent} from "../notification-dialog-content.component";

interface LotteryDialogListItemContext {
  $implicit: ApartmentWithApplicationInfo;
}

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'ng-template[lotteryDialogListItem]',
  standalone: true,
})
export class LotteryDialogListItemDirective {
  static ngTemplateContextGuard(
    dir: LotteryDialogListItemDirective,
    ctx: unknown
  ): ctx is LotteryDialogListItemContext {
    return true;
  }
}

@Component({
  selector: 'homey-lotteries-dialog-content',
  imports: [
    LotteryListComponent,
    LotteryListItemDirective,
    NgTemplateOutlet,
    NotificationDialogContentComponent,
  ],
  templateUrl: './lotteries-dialog-content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LotteriesDialogContentComponent {
  public readonly closeButton = input.required<TemplateRef<any>>();
  public readonly notification = input.required<{
    lotteries: string[]
  }>();
  public readonly singleTitle = input.required<string>();
  public readonly multipleTitle = input.required<string>();
  public readonly multipleDescription = input.required<string>();
  public readonly singleDescription = input.required<string>();
  public readonly lotteryListItem = contentChild.required(LotteryDialogListItemDirective, {read: TemplateRef});
  public readonly apartmentIds = computed(() => this.notification().lotteries);
  private readonly applicationService = inject(ApplicationService);
  protected readonly lotteries = this.applicationService.getApartmentsByIds(this.apartmentIds);
}
